import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/searchspring/components/collection/filters/FilterSelected'
import { SortItem } from '@/components/libs/searchspring/components/collection/filters/SortItem'
import { calculateProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { useEffect, useRef } from 'preact/hooks'

export function FilterDrawer({ id = 'filters' }) {
  const { handleClearFilters, handleToggleFilter, handleRemoveFilter, activeFilters, fetchedFilters } = useFilters()

  const { results } = useInfiniteScrollResults()
  const totalResults = calculateProductCount(results)
  const drawerRef = useRef(null)

  useEffect(() => {
    const handleOpenFilters = () => {
      const drawer = drawerRef.current
      if (drawer && drawer.dataset.ui !== 'visible') {
        drawer.handleToggle?.()
      }
    }

    window.addEventListener('searchspring:open-filters', handleOpenFilters)
    return () => window.removeEventListener('searchspring:open-filters', handleOpenFilters)
  }, [])

  return (
    <x-modal ref={drawerRef} className="group/filters z-60" data-id={id} data-body-lock>
      <div className="pointer-events-none fixed left-0 top-0 z-60 flex h-view w-full flex-col transition-all group-data-visible/filters:pointer-events-auto">
        <div className="z-2 flex size-full max-w-[338px] -translate-x-full-margin flex-col bg-secondary transition-all group-data-visible/filters:translate-x-0 lg:max-w-[413px]">
          <div class="flex shrink-0 flex-col">
            <div className="flex h-[60px] w-full items-center justify-between gap-x-gutter border-b border-neutral-medium px-margin md:px-1.5">
              <h2 className="h4">Filters & Sort</h2>
              <button
                className="size-[14px] children:size-full"
                data-modal-parent={id}
                data-modal-role="close"
                aria-label="Close Filters"
              >
                <Icon id="close" />
              </button>
            </div>
            <SortItem />
            <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          </div>
          <div className="flex grow flex-col overflow-y-scroll overscroll-none no-scrollbar">
            {fetchedFilters.length > 0 ? (
              fetchedFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  onRemove={handleRemoveFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <p className="px-1.5 py-1.5 text-neutral-secondary">No filters available</p>
            )}
          </div>
          <div className="flex w-full shrink-0 flex-col gap-y-0.5 border-t border-neutral-medium bg-brand-white px-1.5 pb-0.5 pt-1.5">
            <button
              className="w-full btn btn-fill btn-primary btn-m"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="View Results"
            >
              <span>View {totalResults} Results</span>
            </button>
            {activeFilters.size > 0 && (
              <button
                className="w-full btn btn-text btn-primary btn-s"
                onClick={handleClearFilters}
                aria-label="Clear Filters"
              >
                <span className="text-line">Clear Selections</span>
              </button>
            )}
          </div>
        </div>
        <button
          class="pointer-events-none fixed size-full cursor-w-resize bg-neutral-black/60 opacity-0 transition-all inset-tl group-data-visible/filters:pointer-events-auto group-data-visible/filters:opacity-100"
          data-modal-parent={id}
          data-modal-role="close"
          aria-label="Close Filters"
        ></button>
      </div>
    </x-modal>
  )
}
